/* eslint-disable @typescript-eslint/no-explicit-any */
import { parseJwt } from "../helper";

export const setCurrentUser = (dispatch: any, token: string) => {
  const data = parseJwt(token);
  const tokenInfo = JSON.parse(token) as { accessToken: string };
  sessionStorage.setItem("token", tokenInfo.accessToken);
  dispatch({
    type: "SET_CURRENT_USER",
    payload: { ...data, ...tokenInfo },
  });
};

export const saveFilters = (dispatch: any, data: any) => {
  dispatch({
    type: "SAVE_FILTERS",
    payload: { ...data },
  });
};
